import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const editProfile = createAsyncThunk(
  "editProfile/editProfile",
  async (payload, thunkAPI) => {
    try {
      const response = await api.patch(`edit-profile/${payload.id}`, payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const editProfileSlice = createSlice({
  name: "editProfile",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(editProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(editProfile.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(editProfile.rejected, (state, action) => {
       
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default editProfileSlice.reducer;
